module.exports = __webpack_public_path__ + "static/media/presentation_2.c7c251d8.svg";